import { render, staticRenderFns } from "./Integer.vue?vue&type=template&id=36eb384a"
import script from "./Integer.vue?vue&type=script&lang=js"
export * from "./Integer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports